var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { plansTables } from '../plan-features-definition';
var PlansTableComponent = /** @class */ (function () {
    function PlansTableComponent() {
        this.subscribePlan = new EventEmitter();
        this.fullComparision = false;
    }
    PlansTableComponent.prototype.ngOnInit = function () {
        this.mainTable = plansTables[0];
        this.secondaryTables = plansTables
            .slice(1)
            .map(function (features) { return (__assign({}, features, { rows: features.rows.filter(function (row) { return !row.hidden; }) })); });
    };
    PlansTableComponent.prototype.onSubscribePlan = function (plan) {
        this.subscribePlan.emit(plan);
    };
    PlansTableComponent.prototype.isCurrentSubscription = function (plan) {
        return (this.currentSubscription &&
            this.currentSubscription.licenses &&
            this.currentSubscription.licenses.some(function (license) { return license.planId === plan.id; }));
    };
    PlansTableComponent.prototype.showFullComparision = function () {
        this.fullComparision = true;
    };
    return PlansTableComponent;
}());
export { PlansTableComponent };
